import { createSelector } from '@reduxjs/toolkit';
import type { ServerModeState } from './factory';
import { ServerModes } from './types';

/**
 * The slice of the root state this package reads. The app registers the MM
 * reducer under `mmServerMode` and the ES reducer under `esServerMode`.
 */
export interface ServerModeStore {
  mmServerMode: ServerModeState;
  esServerMode: ServerModeState;
}

// One factory per channel key, so a channel's selectors cannot read the
// other channel's state by a copy-paste slip.
function createChannelSelectors<K extends keyof ServerModeStore>(key: K) {
  const selectServerMode = (state: Pick<ServerModeStore, K>) => state[key].serverMode;
  const selectShouldNotify = (state: Pick<ServerModeStore, K>) => state[key].shouldNotifyServerMode;
  const selectMaintenance = createSelector(
    selectServerMode,
    (serverMode) => serverMode === ServerModes.ReadOnly,
  );

  return { selectServerMode, selectShouldNotify, selectMaintenance };
}

export const {
  selectServerMode: selectMmServerMode,
  selectShouldNotify: selectMmShouldNotify,
  selectMaintenance: selectMmMaintenance,
} = createChannelSelectors('mmServerMode');

export const {
  selectServerMode: selectEsServerMode,
  selectShouldNotify: selectEsShouldNotify,
  selectMaintenance: selectEsMaintenance,
} = createChannelSelectors('esServerMode');
